import React, { Component, useState } from "react";
import { Translation } from "react-i18next";
import i18n from "i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import {
    Button,
    MenuItem,
    Select,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    DialogContentText,
    CircularProgress,
    TablePagination,
} from "@material-ui/core";
import clsx from "clsx";
import { TextInput } from "../../../util/input-elements/TextInput";
import { _PermittedSetting } from "../../../_module/utils/PermittedSetting";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import {
    search,
    trackInputSearch,
    clearTrackInput,
    prsSearch,
    showMessage,
    prsWorkSearch
} from "../../../redux/actions/MlTrackLibraryActions";
import RefreshIcon from "@material-ui/icons/Refresh";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// import trackFields from "../../../_module/definition/trackFields";
import Columns from "../../../modules/ml-licensing/clearance-form/trackInputColumn";
import TableDataCol from "../../../util/TableDataCol";
import { postItem } from "../../../redux/actions/MlLicFormActions";
import { styles } from "./Styles.css";

// import { PlaylistItemTypes } from "../../ml-music-search/track/RecentPlaylistMenu";

import Grid from "@material-ui/core/Grid";
import { defaultPopupResults, resultsPerPage } from "../../../redux/Types";
import TableHeaderCol from "../../../util/TableHeaderCol";
import ChipInput from "material-ui-chip-input";
import { FaEraser } from "react-icons/fa";
import { deepCopyFunction } from '../../../util/CommonFunc'
import {
    setPrsTrackToEditTrack
} from "../../../redux/actions/MLTrackUpdateAction";
import store from "redux/Store";

class PrsSearch extends Component {

    origins;
    isPrsSearch = true;
    isDataImportedFromPrs = false;
    displayFields = [
        "trackTitle",
        "performer",
        "prs",
        "musicOrigin",
        "isrc",
        "iswc",
        "catNo",
        "recordLabel",
        // "publisher",
        // "composer",
        "duration"
    ];
    rowsPerPage = defaultPopupResults;
    page = 0;
    startRecord = 1;
    totalResults = 0;

    mlSearchFields = [
        {
            id: 'all',
            label: 'All'
        },
        {
            id: 'trackTitle',
            label: 'Track Title'
        },
        {
            id: 'publisher',
            label: 'Publisher'
        },
        {
            id: 'performer',
            label: 'Artist'
        },
        {
            id: 'catNo',
            label: 'Catalog #'
        },
        {
            id: 'isrc',
            label: 'ISRC'
        },
        {
            id: 'composer',
            label: 'Composer'
        },
    ];

    prsSearchFields = [
        {
            id: 'Tunecode',
            label: 'PRS Tune Code',
            selectorLabel: 'PRS Tune Code',
        },
        {
            id: 'IsrcNo',
            label: 'ISRC',
            selectorLabel: 'ISRC',
        },
        {
            id: 'ArtistName1',
            label: 'Artist',
            selectorLabel: 'Title and Artist',
        },
        {
            id: 'Title',
            label: 'Title',
            selectorLabel: 'Title',
        }
    ];

    constructor(props) {
        super();
        this.state = {
            dialogOpen: false,
            errors: {},
            selectedTrack: null,
            reload: false,
            selectedPrsTrack: null,
            alertMessage: false,
            componentUpdate: true,
            confirmMessageOpen: false,
            mlSearch: {
                text: "",
                field: "all"
            },
            prsSearch: {
                Title: "",
                ArtistName1: "",
                ProdTitle: "",
                ProdLabel: "",
                IsrcNo: "",
                ProdCatNo: "",
                Tunecode: "",
            },
            customTrack: {
                dhTrackId: "", //string
                archived: false, //bool
                restricted: false, //bool
                trackTitle: "", //string
                catNo: "", //string
                duration: "", //float
                iswc: "", //string
                isrc: "", //string
                musicOrigin: "", //string
                prodName: "", //string
                recordLabel: "", //list<string>
                territories: [], //collection<string>
                composer: [], //list<string>
                performer: [], //list<string>
                arranger: [],  //list<string>
                prs: "", //string
                position: "", //string
                prodDiscNr: "", //string
                bpm: "", //string
                tempo: "", //string
                trackNotes: "", //string
                publisher: [], //list<string>
                lyricist: [], //list<string>
                translator: [], //list<string>
            },
            prsSearchId: "",
            prsSessionId: "",
            prsSelectedField: "Title",
            importedFields: []
        }
        this.openDialog = this.openDialog.bind(this);
        this.closeDialog = this.closeDialog.bind(this);

        this.advSearches = _PermittedContent(
            [props.orgRuntime.runtime._mlLibraries, props.orgRuntime.runtime._libraryAdvSearchType],
            []
        );

        const searchConfig =
            this.advSearches.find((v) => v.id === props.data.query.advSearch) ||
            this.advSearches[0];

        this.origins =
            _PermittedSetting(searchConfig.setting, [
                props.orgRuntime.runtime._settingMusicSearch,
                props.orgRuntime.runtime._settingSearchOrigin,
            ]) || [];
    }

    handleClick() { }

    handleValChange = (event) => {
        const { mlSearch } = this.state;
        mlSearch[event.target.name] = event.target.value;
        this.setState({
            mlSearch: mlSearch,
        });
    };

    handleCustomValChange = (event) => {
        const { customTrack } = this.state;
        customTrack[event.target.name] = event.target.value;
        this.setState({
            customTrack: customTrack,
            prsSearchId: ""
        });
    };

    handlePrsValChange = (event) => {
        const { prsSearch } = this.state;
        prsSearch[event.target.name] = event.target.value;
        this.setState({
            prsSearch: prsSearch,
            prsSearchId: ""
        });
    };

    isExistingCFTrack(trackId) {
        const { cfFormContent } = this.props;
        let index = cfFormContent.editing.clearance.tracks.findIndex(
            (item) => item == trackId
        );
        if (index != -1) return true;
        else return false;
    }

    resetData = () => {
        const { clearTrackInput } = this.props;
        this.setState({
            errors: null,
            selectedTrack: null,
            selectedPrsTrack: null,
            alertMessage: false,
            mlSearch: {
                text: "",
                field: "all"
            },
            prsSearch: {
                Title: "",
                ArtistName1: "",
                ProdTitle: "",
                ProdLabel: "",
                IsrcNo: "",
                ProdCatNo: "",
                Tunecode: "",
            },
            customTrack: {
                archived: false,
                restricted: false,
                trackTitle: "",
                catNo: "",
                duration: "",
                iswc: "",
                isrc: "",
                musicOrigin: "",
                prodName: "",
                recordLabel: "",
                territories: [],
                composer: [],
                performer: [],
                arranger: [],
                prs: "",
                position: "",
                prodDiscNr: "",
                bpm: "",
                tempo: "",
                trackNotes: "",
                publisher: [],
                lyricist: [],
                translator: [],
            },
            prsSearchId: "",
            prsSessionId: "",
            prsSelectedField: "Title",
            importedFields: []
        });
        this.page = 0;
        clearTrackInput();
    };


    openDialog() {
        this.setState({
            dialogOpen: true, reload: true
        });
    }

    closeDialog() {
        const { selectedPrsTrack } = this.state;
        const { setPrsTrackToEditTrack, prsWorkSearch } = this.props;
        this.isDataImportedFromPrs = false;
        this.setState({
            dialogOpen: false,
            selectedTrack: null,
            confirmMessageOpen: false
        });

        this.resetData();
        setPrsTrackToEditTrack(selectedPrsTrack, true, 'no');

    }




    setTotalItems() {
        const {
            data: {
                trackInputData: { totalItems },
            },
        } = this.props;
        this.totalResults =
            totalItems !== undefined ? totalItems !== this.totalResults ? totalItems : this.totalResults : this.totalResults;
    }

    handleChangeRowsPerPage = (event) => {
        let rowsPerPage = !isNaN(event.target.value)
            ? +event.target.value
            : this.rowsPerPage;


        const {
            data: { trackInputData },
            trackInputSearch,
        } = this.props;
        trackInputSearch(
            {
                ...trackInputData.query,
                q: this.state.mlSearch.text,
                qfs: [this.state.mlSearch.field],
                page: 0,
                size: rowsPerPage,
            },
            false,
            () => {
            }
        );
        this.rowsPerPage = rowsPerPage;
        this.page = 0;

    };

    handleChangePageMLSearch = (event, value) => {
        const {
            data: { trackInputData },
            trackInputSearch,
        } = this.props;
        trackInputSearch(
            {
                ...trackInputData.query,
                q: this.state.mlSearch.text,
                qfs: [this.state.mlSearch.field],
                page: value ? value : 0
            },
            false,
            () => {

            }
        );
        this.page = value;
    };



    handleChangePageSearchPRS = (event, value) => {
        const {
            data: {
                trackInputData,
            },
            prsSearch,
        } = this.props;
        this.setState({
            isError: false
        })

        let prsData = {
            // ...this.state.prsSearch, 
            searchId: this.state.prsSearchId,
            startRecord: value == 0 ? 1 : (value == this.page + 1) ? (this.startRecord + 20) : (value == this.page - 1) ? (this.startRecord - 20) : 1,
            sessionId: this.state.prsSessionId,
            sessionExp: null,
        };
        if (this.state.prsSearch.Tunecode) {
            prsData['Tunecode'] = this.state.prsSearch.Tunecode;
        }
        else if (this.state.prsSearch.IsrcNo) {
            prsData['IsrcNo'] = this.state.prsSearch.IsrcNo;
        }
        else if (this.state.prsSearch.ArtistName1.length > 0 && this.state.prsSearch.Title) {
            prsData['ArtistName1'] = Array.isArray(this.state.prsSearch.ArtistName1) ? this.state.prsSearch.ArtistName1.join(', ') : this.state.prsSearch.ArtistName1;
            prsData['Title'] = this.state.prsSearch.Title;
        }
        else if (this.state.prsSearch.Title) {
            prsData['Title'] = this.state.prsSearch.Title;
        }
        else if (this.state.prsSearch.ArtistName1.length > 0) {
            prsData['ArtistName1'] = Array.isArray(this.state.prsSearch.ArtistName1) ? this.state.prsSearch.ArtistName1.join(', ') : this.state.prsSearch.ArtistName1;
        }

        prsSearch(
            { ...trackInputData.query },
            prsData,
            (res, err = null) => {
                if (!err) {
                    this.setState({
                        prsSearchId: res.searchId,
                        prsSessionId: res.sessionId
                    });
                }
                else {
                }
            }
        );
        this.page = value;
        this.startRecord = prsData.startRecord;
    }



    searchPRS() {
        const {
            data: { trackInputData },
            prsSearch,
        } = this.props;
        this.setState({
            isError: false
        })

        let prsData = {
            // ...this.state.prsSearch, 
            searchId: this.state.prsSearchId,
            startRecord: 1,
            sessionId: this.state.prsSessionId,
            sessionExp: null,
        };
        if (this.state.prsSearch.Tunecode) {
            prsData['Tunecode'] = this.state.prsSearch.Tunecode;
        }
        else if (this.state.prsSearch.IsrcNo) {
            prsData['IsrcNo'] = this.state.prsSearch.IsrcNo;
        }
        else if (this.state.prsSearch.ArtistName1.length > 0 && this.state.prsSearch.Title) {
            prsData['ArtistName1'] = Array.isArray(this.state.prsSearch.ArtistName1) ? this.state.prsSearch.ArtistName1.join(', ') : this.state.prsSearch.ArtistName1;
            prsData['Title'] = this.state.prsSearch.Title;
        }
        else if (this.state.prsSearch.Title) {
            prsData['Title'] = this.state.prsSearch.Title;
        }
        else if (this.state.prsSearch.ArtistName1.length > 0) {
            prsData['ArtistName1'] = Array.isArray(this.state.prsSearch.ArtistName1) ? this.state.prsSearch.ArtistName1.join(', ') : this.state.prsSearch.ArtistName1;
        }

        prsSearch(
            { ...trackInputData.query },
            prsData,
            (res, err = null) => {
                if (!err) {
                    this.setState({
                        prsSearchId: res.searchId,
                        prsSessionId: res.sessionId
                    });
                }
                else {
                }
            }
        );
    }

    isVisibleField(field) {
        return this.state.prsSelectedField == 'Tunecode' ? (field == 'Tunecode' ? false : true) :
            this.state.prsSelectedField == 'IsrcNo' ? (field == 'IsrcNo' ? false : true) :
                // this.state.prsSelectedField == 'ProdCatNo'?(field == 'ProdCatNo'?false:true):
                // this.state.prsSelectedField == 'ProdLabel'?(['ProdTitle', 'ProdLabel'].indexOf(field) != -1?false:true):
                ['Title',].indexOf(this.state.prsSelectedField) != -1 ? (['Title'].indexOf(field) != -1 ? false : true) :
                    ['ArtistName1'].indexOf(this.state.prsSelectedField) != -1 ? (['ArtistName1', 'Title'].indexOf(field) != -1 ? false : true) : false;
        // ['ArtistName1', 'Title', 'ProdTitle'].indexOf(this.state.prsSelectedField) != -1?(['ArtistName1', 'Title', 'ProdTitle'].indexOf(field) != -1?false:true):false;
    }


    onPrsFieldSelected = (event) => {
        // const { customTrack } = this.state;
        let ps = {
            Title: "",
            ArtistName1: "",
            IsrcNo: "",
            Tunecode: "",
        }
        
        this.setState({
            prsSelectedField: event.target.value,
            prsSearch: ps
        });
    }

    handleSelectTrack = () => {
        this.setState({ confirmMessageOpen: true })
    }

    handleMessageConfirm = (e) => {
        const { selectedPrsTrack } = this.state;
        const { setPrsTrackToEditTrack, prsWorkSearch } = this.props;
        setPrsTrackToEditTrack(selectedPrsTrack, true, 'yes');
        this.setState({
            dialogOpen: false,
            selectedTrack: null,
            confirmMessageOpen: false
        });
    }

    componentDidUpdate() {
        this.setDefault();
    }

    setDefault() {
        const { updateData: { trackEditing } } = this.props;

        if (trackEditing && this.state.reload) {
            this.setState({
                reload: false,
            });
            if (trackEditing.trackMetadata.prs_tune_code) {
                this.setState({
                    prsSelectedField: "Tunecode"
                });
                this.state.prsSearch["Tunecode"] = trackEditing.trackMetadata.prs_tune_code;
            }
            else if (trackEditing.trackMetadata.isrc) {
                this.setState({
                    prsSelectedField: "IsrcNo"
                });
                this.state.prsSearch["IsrcNo"] = trackEditing.trackMetadata.isrc;

            }
            else if (trackEditing.trackMetadata.track_title && (trackEditing.trackMetadata.performers && trackEditing.trackMetadata.performers.length > 0)) {
                this.setState({
                    prsSelectedField: "ArtistName1",
                });
                this.state.prsSearch["Title"] = trackEditing.trackMetadata.track_title;
                this.state.prsSearch["ArtistName1"] = trackEditing.trackMetadata.performers[0];

            }
            else if (trackEditing.trackMetadata.track_title) {
                this.setState({
                    prsSelectedField: "Title", prsSearch: trackEditing.trackMetadata.track_title
                });
                this.state.prsSearch["Title"] = trackEditing.trackMetadata.track_title;

            }
            this.searchPRS();
        }
    }
    
    onEnterButton=(e)=>{
        this.searchPRS();
    }

    render() {
        const {
            classes,
            data: {
                query: { advSearch },
                trackInputData: { items, loading, prsLoading },
            },
            cf: {
                posting: { busy },
            },
            cfFormContent,
            buttonText
        } = this.props;

        const {
            selectedPrsTrack,
            confirmMessageOpen
        } = this.state;

        const {
            orgRuntime: {
              runtime: {
                _trackFields: trackFields,
            
              }
            }
          } = store.getState(); 

        this.columns = this.displayFields.map((v) => {
            let label =
                !trackFields[v] || trackFields[v]?.sys ? "" : i18n.t(`modules.${v}`);
            return {
                ...(Columns[v] || {}),
                field: v,
                type: Columns[v].type,
                label,
            };
        });
        this.setTotalItems();
        return (
            <Translation>
                {(t, { i18n }) => (
                    <>
                        {/* <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            className={classes.appbarAddButton}
                            aria-controls="addTrack"
                            aria-haspopup="true"
                            onClick={this.openDialog}
                        >
                            PRS Search
                        </Button> */}

                        <Dialog
                            open={confirmMessageOpen}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            className={classes.dialogWrapper}
                            class="dialogBox"
                        >
                            <DialogTitle id="alert-dialog-title">
                                {"Confirmation Alert"}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Would you like to update track information?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    className={classes.dialogYesButton}
                                    onClick={(e) => {
                                        this.handleMessageConfirm(e);
                                    }}
                                    color="primary"
                                    autoFocus
                                >
                                    Yes
                                </Button>
                                <Button
                                    className={classes.dialogNoButton}
                                    onClick={() => this.closeDialog()}
                                    color="primary"
                                >
                                    No
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={this.state.dialogOpen}
                            id="add-track-dialog"
                            aria-labelledby="add-track-dialog"
                            class="addTracktoClearance "
                        >
                            <DialogTitle>
                                {" "}
                                Search in PRS
                            </DialogTitle>
                            <DialogContent>


                                {/* -------------------- */}
                                {
                                    this.isPrsSearch && (
                                        <div className={classes.searchPRSWrapper}>
                                            <Select
                                                name="field"
                                                variant="outlined"
                                                value={this.state.prsSelectedField || ""}
                                                onChange={this.onPrsFieldSelected}
                                            >
                                                {
                                                    this.prsSearchFields.map(d => {
                                                        return <MenuItem value={d.id}>{d.selectorLabel}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                            {this.prsSearchFields.map(d => {
                                                return this.isVisibleField(d.id) ? "" : <div
                                                onKeyDown={(e) => this.onEnterButton(e)}>
                                                    {/* <label className={""} aria-label={d.label}>{d.label}</label> */}
                                                    <TextInput
                                                        name={d.id}
                                                        type="text"
                                                        classes={""}
                                                        variant="outlined"
                                                        label={d.label}
                                                        handleChange={this.handlePrsValChange}
                                                        errors={this.state.errors || {}}
                                                        value={this.state.prsSearch[d.id] || ""}
                                                        onPressEnterKeySearch={() => {
                                                        }}
                                                        // disabled={this.disibleField(d.id)}
                                                        inputProps={{
                                                            "aria-label": d.label,
                                                            maxLength: d.id == 'ArtistName1' ? 50 : 1000
                                                        }}
                                                    />
                                                </div>;
                                            })}
                                            <Button
                                                className={clsx(classes.SearchButton, classes.appbarRefreshButton)}
                                                variant="contained"
                                                aria-label={"Search PRS"}
                                                onClick={(e) => {
                                                    this.searchPRS();
                                                }}
                                                color="primary"
                                                autoFocus
                                            > <RefreshIcon style={{ fontSize: 18 }} />  Search</Button>
                                            <Button
                                                title={"Clear search terms"}
                                                type="button"
                                                variant="contained"
                                                color="primary"
                                                aria-label={"Clear search terms"}
                                                className={clsx(classes.appbarRefreshButton, classes.resetDataButton)}
                                                disabled={busy ? true : false}
                                                onClick={() => {
                                                    const { clearTrackInput } = this.props;
                                                    const { prsSearch } = this.state;
                                                    prsSearch.Title = "";
                                                    prsSearch.ArtistName1 = "";
                                                    prsSearch.IsrcNo = "";
                                                    prsSearch.Tunecode = "";
                                                    this.setState({
                                                        prsSearch: prsSearch
                                                    }, () => {
                                                        clearTrackInput();
                                                    })
                                                }}
                                            >
                                                <FaEraser style={{ fontSize: 15 }} />
                                            </Button>
                                        </div>
                                    )
                                }
                                {
                                    (this.isPrsSearch) && (
                                        <div>
                                            <div className={classes.relativeDiv}>
                                                <TableContainer className={classes.tableMaxHeight}>
                                                    <Table stickyHeader className={""}>
                                                        <TableHead>
                                                            <TableRow>
                                                                {this.columns.map((column) => (
                                                                    <TableHeaderCol
                                                                        columns={this.columns}
                                                                        key={column.field}
                                                                        {...this.props}
                                                                        column={column}
                                                                    />
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {items &&
                                                                items.length > 0 &&
                                                                items.map((row) => {
                                                                    return (
                                                                        <TableRow
                                                                            key={row.id}
                                                                            className={""}
                                                                            selected={
                                                                                !this.isPrsSearch ? (this.state.selectedTrack &&
                                                                                    row.id == this.state.selectedTrack.id) : (this.state.selectedPrsTrack &&
                                                                                        row.id == this.state.selectedPrsTrack.id)
                                                                            }
                                                                            onClick={() => {
                                                                                if (this.isPrsSearch) {
                                                                                    this.setState({
                                                                                        selectedPrsTrack: row,
                                                                                    });
                                                                                }
                                                                            }}
                                                                        >
                                                                            {this.columns.map((c, i) => (
                                                                                <TableDataCol
                                                                                    key={c.field + row.id}
                                                                                    {...this.props}
                                                                                    column={c}
                                                                                    row={row}
                                                                                    rowId={row.id}
                                                                                    selected={
                                                                                        !this.isPrsSearch ? (this.state.selectedTrack &&
                                                                                            row.id == this.state.selectedTrack.id) : (this.state.selectedPrsTrack &&
                                                                                                row.id == this.state.selectedPrsTrack.id)
                                                                                    }
                                                                                />
                                                                            ))}
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                {items && !items.length && !loading && !prsLoading && (

                                                    <div className={classes.noData}>
                                                        {t("tableView.noDataToPreview")}
                                                    </div>

                                                )}
                                                {items && !items.length && (loading || prsLoading) && (

                                                    <CircularProgress
                                                        size={40}
                                                        className={classes.progressnew}
                                                    />

                                                )}
                                            </div>
                                            <div className={classes.tracksPagination}>
                                                <TablePagination
                                                    labelRowsPerPage={""}
                                                    rowsPerPageOptions={this.isPrsSearch ? [20] : resultsPerPage}
                                                    component={"div"}
                                                    count={this.totalResults} //total records count
                                                    rowsPerPage={this.isPrsSearch ? 20 : this.rowsPerPage}
                                                    page={this.page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            "aria-label": "results per page",
                                                            id: "trackInputPaging",
                                                            "aria-labelledby": "trackInputPaging",
                                                        },
                                                    }}
                                                    onChangePage={this.isPrsSearch ? this.handleChangePageSearchPRS : this.handleChangePageMLSearch}
                                                    onChangeRowsPerPage={this.isPrsSearch ? null : this.handleChangeRowsPerPage}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                                {/* -------------------- */}


                            </DialogContent>
                            <DialogActions className={""}>
                                <Button
                                    className={classes.globalGrayButton}
                                    onClick={(e) => {
                                        this.handleSelectTrack();
                                    }}
                                    autoFocus
                                    disabled={!selectedPrsTrack ? true : false}
                                >
                                    Select Track
                                </Button>
                                <Button
                                    className={classes.globalGrayButton}
                                    onClick={(e) => {
                                        this.closeDialog();
                                    }}
                                    autoFocus
                                >
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </>
                )}
            </Translation>
        );
    }
}

const mapStateToProps = (state) => ({
    data: state.mltracklibrary,
    cfFormContent: state.mllicformcontent,
    cf: state.mllicform,
    user: state.user,
    updateData: state.mlTrackUpdateReducer,
    orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
    search,
    trackInputSearch,
    clearTrackInput,
    prsSearch,
    postItem,
    showMessage,
    setPrsTrackToEditTrack,
    prsWorkSearch
})(withStyles(styles)(PrsSearch));
